import { render, staticRenderFns } from "./TheNotice.vue?vue&type=template&id=556330f4&"
import script from "./TheNotice.vue?vue&type=script&lang=ts&"
export * from "./TheNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports